import { ACTION } from "./authActions";

export const initialState = {
    user: null,
    isAuthenticated: false,
  };
  
  export const authReducer = (state, action) => {
    switch (action.type) {
      case ACTION.LOGIN:
        return {
          ...state,
          user: action.payload.user,
          isAuthenticated: true,
        };
      case ACTION.LOGOUT:
        return {
          ...state,
          user: null,
          isAuthenticated: false,
        };
      default:
        return state;
    }
  };
  